import DetailsButton from './DetailsButton'

export default DetailsButton
